<template>
  <div class="tab-item">
    <div class="detail-page-block">
      <template v-if="substance.products && substance.products.length">
        <h2 class="orange">Liste des produits contenant la substance active</h2>
        <ul
          v-for="(product, i) in substance.products"
          :key="i"
        >
          <router-link :to="{ name: 'productIdentity', params: { id: product.pk } }" class="flex">
            <li class="mr-3 mb-2 mt-px" style="font-size:20px">- {{ product.name }}</li>
            <div v-if="product.logo_biocontrole" class="has-tooltip mr-2">
              <img
                src="@/assets/images/coccifeuille.png"
                alt="Logo Biocontrôle"
                style="object-fit: cover; width: 19px;"
              />
              <span class="tooltip">PPP de biocontrôle (liste ministère)</span>
            </div>
            <div v-if="product.logo_ab_use" class="has-tooltip mr-1">
            <img
              src="@/assets/images/picto-UAB.png"
              alt="Logo Agriculture Biologique"
              style="object-fit: cover; width: 25px;"
            />
            <span class="tooltip">Utilisable en agriculture biologique</span>
          </div>
          <div v-if="product.gamme_amateur" class="has-tooltip mr-2">
            <img
              style="object-fit: cover; width: 35px;"
              src="@/assets/images/brouette-01_fond-transparent.png"
              alt="Utilisable par les amateurs / EAJ"
            />
            <span class="tooltip">Utilisable par les amateurs / EAJ</span>
          </div>
          </router-link>
        </ul>
      </template>
      <p v-else>Aucun produit n'est actuellement lié à cette substance.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubstanceProducts',

  props: {
    substance: Object
  }
}
</script>
